<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-5">
    <div style="max-width:680px">
      <h3 class="mb-1">Dintero Miljø Config</h3>
      <div style="font-style: italic; color:var(--bo-muted)">
        <strong>Global</strong> Dintero-plattformkonfig. I motsetning til Viva bruker Dintero <strong>samme URL-er
        for sandbox og produksjon</strong> — det er <code>account_id</code>-en som avgjør miljøet
        (<code>T…</code> = test, <code>P…</code> = produksjon). Derfor er det <strong>ingen miljø-bryter</strong>;
        URL-ene er faste konstanter. Det eneste konfigurerbare er token-cache-TTL.
      </div>
      <div class="alert alert-secondary mt-2 py-2" style="font-size:0.84rem">
        Per-merchant Dintero-nøkler settes på <code>/dintero</code> (kontosiden), ikke her.
      </div>

      <config-lock ref="lock" :configured="isConfigured">
      <div class="mt-4" style="max-width:320px">
        <label class="form-label mb-1" style="font-size:0.85rem; color:var(--bo-muted)">
          Access-token cache TTL (millisekunder)
        </label>
        <input class="form-control" type="number" min="60000" step="60000" v-model.number="form.cachingTtlMs" />
        <div style="color:var(--bo-muted); font-size:0.78rem" class="mt-1">
          Hvor ofte token-cachen tømmes. DEV 300000 (5 min), PROD 10800000 (3 t). Sjekkes hvert minutt.
        </div>
      </div>

      <div class="mt-4 d-flex align-items-center gap-3">
        <button class="bo_btn" @click="save" :disabled="saving">{{ saving ? 'Lagrer…' : 'Lagre' }}</button>
        <span v-if="message" :class="error ? 'text-danger' : 'text-success'">{{ message }}</span>
      </div>
      </config-lock>

      <div class="mt-4">
        <div class="fw-semibold mb-1" style="font-size:0.9rem">Endepunkt-URL-er (konstanter)</div>
        <table class="table table-sm url-preview">
          <tbody>
            <tr><td>audience</td><td><code>{{ config.audience }}</code></td></tr>
            <tr><td>access token</td><td><code>{{ config.accessTokenUrl }}</code></td></tr>
            <tr><td>initiate</td><td><code>{{ config.initiatePaymentUrl }}</code></td></tr>
            <tr><td>session pay (MIT)</td><td><code>{{ config.sessionPayUrl }}</code></td></tr>
            <tr><td>capture</td><td><code>{{ config.capturePaymentUrl }}</code></td></tr>
            <tr><td>cancel (void)</td><td><code>{{ config.cancelPaymentUrl }}</code></td></tr>
            <tr><td>get status</td><td><code>{{ config.getPaymentStatusUrl }}</code></td></tr>
            <tr><td>refund</td><td><code>{{ config.refundPaymentUrl }}</code></td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfigLock from "@/components/other/ConfigLock";
import SettingsService from "@/services/settings/SettingsService";

export default {
  name: "DinteroConfig",
  components: { LoadingSpinner, ConfigLock },
  computed: {
    // Already configured (→ starts locked): the server returned a saved TTL (the only editable value;
    // a fresh/empty config has no `cachingTtlMs`, so it stays editable).
    isConfigured() { return !!this.config.cachingTtlMs; }
  },
  data() {
    return {
      loading: true,
      config: {},
      form: { cachingTtlMs: 300000 },
      saving: false,
      message: "",
      error: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      SettingsService.getDinteroConfig().then(
        (response) => {
          this.config = response.data || {};
          this.form.cachingTtlMs = this.config.cachingTtlMs || 300000;
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke hente konfigurasjon.");
        }
      );
    },
    save() {
      this.saving = true;
      this.message = "";
      this.error = false;
      SettingsService.saveDinteroConfig({ cachingTtlMs: this.form.cachingTtlMs }).then(
        (response) => {
          this.saving = false;
          this.config = response.data || {};
          this.error = false;
          this.message = "Lagret ✓ — tas i bruk umiddelbart (ingen restart).";
          this.$refs.lock.relock();   // re-lock after a successful save
        },
        (error) => {
          this.saving = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke lagre konfigurasjon.");
        }
      );
    },
    errMsg(error, fallback) {
      const data = error && error.response ? error.response.data : null;
      return (data && data.error) || fallback;
    }
  }
};
</script>

<style scoped>
.url-preview td {
  font-size: 0.82rem;
  vertical-align: middle;
}
.url-preview td:first-child {
  color: var(--bo-muted);
  white-space: nowrap;
  width: 1%;
  padding-right: 1rem;
}
</style>
